import { forwardRef } from "react";
import { MathJax } from "better-react-mathjax";
import {
  canvasContainerStyle,
  canvasStyle,
  xAxisLabelStyle,
  yAxisContainerStyle,
  yAxisLabelStyle,
} from "../style";
import { Legend } from "./Legend";
import { AXIS_ZOOM_MODE } from "../../utils/axisZoom";

// AxisLabel: 軸ラベル表示コンポーネント
function AxisLabel({ label, variable, unit, isVertical, axisFontSize, hoveredAxis,graphHeight }) {
  const containerStyle = isVertical ? yAxisContainerStyle(axisFontSize,graphHeight) : {fontSize:axisFontSize};
  const isActive = hoveredAxis === AXIS_ZOOM_MODE.BOTH || (isVertical ? hoveredAxis === AXIS_ZOOM_MODE.Y : hoveredAxis === AXIS_ZOOM_MODE.X);
  const style = isVertical
    ? { ...yAxisLabelStyle, color: isActive ? "#f59e0b" : "#111827" }
    : { ...xAxisLabelStyle, color: isActive ? "#f59e0b" : "#111827" };

  return (
    <div style={containerStyle}>
      <div style={style}>
        <MathJax>
          {`${label} \\(${variable}\\) / \\(\\mathrm\{${unit}\}\\)`}
        </MathJax>
      </div>
    </div>
  );
}


export default function Graph({
  canvasRef,
  legendRef,
  leftBottom,
  rightTop,
  xLabel,
  yLabel,
  datas,
  legendState,
  axisFontSize,
  hoveredAxis,
  height
}) {

  return (
    <div style={canvasContainerStyle}>
      <canvas ref={canvasRef} style={canvasStyle(height)}/>

      <AxisLabel
        label={xLabel.label}
        variable={xLabel.x}
        unit={xLabel.unit}
        isVertical={false}
        axisFontSize={axisFontSize}
        hoveredAxis={hoveredAxis}
        graphHeight={height}
      />

      <AxisLabel
        label={yLabel.label}
        variable={yLabel.y}
        unit={yLabel.unit}
        isVertical={true}
        axisFontSize={axisFontSize}
        hoveredAxis={hoveredAxis}
        graphHeight={height}
      />

      {legendState?.visible !== false && (
        <Legend ref={legendRef} datas={datas} legendState={legendState} xLabel = {xLabel} yLabel = {yLabel} />
      )}
    </div>
  );
}